export { default as BannerModule } from './BannerModule';
export { default as TextModule } from './TextModule';
export { default as TextWithImage } from './TextWithImage';
export { default as TextBanner } from './TextBanner';
export { default as TextIconCell } from './TextIconCell';
export { default as TextOnImage } from './TextOnImage';
export { default as OtherProductModule } from './OtherProductModule';
export { default as OtherProductCell } from './OtherProductCell';
export { default as SwitchTabModule } from './SwitchTabModule';
export { default as CardModule } from './CardModule';
export { default as ImgCellsWithText } from './ImgCellsWithText';
export { default as VideoModule } from './VideoModule';
export { default as CardSliderModule } from './CardSliderModule';
export { default as CustomerSwiper } from './CustomerSwiper';
export { default as SwiperBanner } from './SwiperBanner';
export { default as TabModule } from './TabModule';
